export default __webpack_public_path__ + "static/media/Email-img.2647c4eb.bin";